import React from 'react';
import { Row, Col, Layout, message } from 'antd'

import RandomizeForm from '../../components/Randomize/Randomize'
import Footer from '../../components/Footer/Footer'
import { randomizeServices } from "../../services";
import classes from './Randomize.css'
import { Results } from '../../components/Results/Results'

const { Content } = Layout;


export default class Randomize extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            group: '',
            tnkDose: '',
            tpaBolusDose: '',
            tpaInfusionDose: '',
            date: '',
            studyID: '',
            weight: '',
            consentType: '',
            randomized: false,
            loading: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleReset = this.handleReset.bind(this)
    }

    handleSubmit(values) {

        this.setState({
            loading: true
        });

        randomizeServices.create(values)
            .then(
                response => {
                    const subject = response.data;

                    if (subject.group === 'tpa') {
                        this.setState({
                            group: subject.group,
                            tpaBolusDose: subject.tpa_bolus_dose,
                            tpaInfusionDose: subject.tpa_infusion_dose,
                            date: subject.randomization_date,
                            studyID: subject.study_id,
                            weight: subject.weight,
                            randomized: true,
                            loading: false
                        });
                    }

                    else if (subject.group === 'tnk_tpa') {
                        this.setState({
                            group: subject.group,
                            tnkDose: subject.tnk_dose,
                            date: subject.randomization_date,
                            studyID: subject.study_id,
                            weight: subject.weight,
                            randomized: true,
                            loading: false
                        });
                    }
                },
                error => {
                    if (error.response) {
                        const errors = error.response.data.error;
                        if (errors) {
                            message.config({ style: { color: '#424242' } })
                            message.error(errors, 5)
                        }
                    }

                    this.setState({
                        group: '',
                        tnkDose: '',
                        tpaBolusDose: '',
                        tpaInfusionDose: '',
                        date: '',
                        studyID: '',
                        weight: '',
                        randomized: false,
                        loading: false
                    });
                });
    }

    handleReset() {
        this.setState({
            group: '',
            tnkDose: '',
            tpaBolusDose: '',
            tpaInfusionDose: '',
            date: '',
            studyID: '',
            weight: '',
            randomized: false,
            loading: false
        })
    }

    render() {
        const { loading, randomized } = this.state;

        return (
            <div style={{ backgroundColor: '#FAFAFA' }}>
                <Layout className={classes.parentContainer}>
                    <Content className={classes.content}>
                        <Row>
                            <Col xs={{ span: 24 }} sm={{ span: 20, offset: 2 }} md={{ span: 16, offset: 4 }} style={{ paddingTop: '4rem' }}>
                                <h1 ><span style={{ color: '#286DA8' }}>AcT</span></h1>
                                {randomized
                                    ? <Results {...this.state} onBackClick={this.handleReset} />
                                    : <RandomizeForm loading={loading} handleSubmit={this.handleSubmit} />
                                }
                            </Col>
                        </Row>
                    </Content>
                    <Footer />
                </Layout>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Randomize/Randomize.js